import { render, staticRenderFns } from "./concept.vue?vue&type=template&id=38f48b42&scoped=true&"
import script from "./concept.vue?vue&type=script&lang=js&"
export * from "./concept.vue?vue&type=script&lang=js&"
import style0 from "./concept.vue?vue&type=style&index=0&id=38f48b42&scoped=true&lang=css&"
import style1 from "./concept.vue?vue&type=style&index=1&id=38f48b42&scoped=true&lang=css&"
import style2 from "./concept.vue?vue&type=style&index=2&id=38f48b42&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f48b42",
  null
  
)

export default component.exports